<template>
  <div class="products" v-loading="loading">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="main">
      <div slot="header" class="toolbar">
        <el-input
          placeholder="请输入品名"
          v-model="inputVal"
          clearable
          @keyup.enter.native="handleSearch"
        />
        <el-input
          placeholder="请输入 SKU"
          v-model="inputSku"
          clearable
          @keyup.enter.native="handleSearch"
        />
        <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
        <el-button type="primary" size="small" @click="addSup">添加产品</el-button>
      </div>

      <div class="card-body">
        <div ref="tableWrap" class="table-wrap">
          <el-table :data="productData" :height="tableHeight" style="width: 100%" border>
        <el-table-column label="操作" width="120" fixed>
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="产品图片" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.picUrl"
              style="max-width: 100px; max-height: 80px;"
              :src="scope.row.picUrl"
              :preview-src-list="[scope.row.picUrl]"
              fit="cover"
            />
            <i v-else class="el-icon-picture-outline image-placeholder"></i>
          </template>
        </el-table-column>
        <el-table-column label="SKU" prop="sku" min-width="140" show-overflow-tooltip />
        <el-table-column label="FNSKU" prop="fnsku" min-width="120" show-overflow-tooltip />
        <el-table-column label="ASIN" prop="asin" min-width="110" show-overflow-tooltip />
        <el-table-column label="中文/英文名称" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
            <div class="sub-text">{{ scope.row.ename }}</div>
          </template>
        </el-table-column>
        <el-table-column label="合规标签" min-width="130">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.riskTags"
              :content="scope.row.riskAdvice || '品名合规风险，请人工复核'"
              placement="top"
            >
              <div>
                <el-tag
                  v-for="(lb, i) in riskTagLabels(scope.row.riskTags)"
                  :key="i"
                  type="danger"
                  size="mini"
                  style="margin:1px"
                >{{ lb }}</el-tag>
              </div>
            </el-tooltip>
            <span v-else class="sub-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="报关编码" prop="hscode" min-width="100" />
        <el-table-column label="材质" prop="material" min-width="90" />
        <el-table-column label="用途" prop="purpose" min-width="90" />
        <el-table-column label="型号" prop="model" min-width="90" />
        <el-table-column label="品牌" min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.brand || '-' }}</div>
            <div class="sub-text">{{ scope.row.brandTypeTxt }}</div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸" prop="size" min-width="90" />
        <el-table-column label="重量" min-width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.weight != null && scope.row.weight !== ''">
              {{ scope.row.weight }}{{ scope.row.weightUnit || '' }}
            </span>
            <span v-else class="sub-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.approvalStatus)" size="small">
              {{ getStatusText(scope.row.approvalStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <span class="empty-tip">暂无产品，点击「添加产品」创建</span>
        </template>
          </el-table>
        </div>

        <div class="pagination-bar">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 40, 60, 80, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>

      <el-dialog
        :title="isAddMode ? '新增产品' : '修改产品'"
        :visible.sync="dialogFormVisible"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        width="900px"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-alert
            v-if="productRiskTip"
            class="product-risk-alert"
            type="warning"
            show-icon
            :closable="false"
            title="品名存在合规风险提示（仅提醒，可继续保存）"
            :description="productRiskTip"
          />
          <div v-if="suggestLoading || suggestKeys.length" class="product-suggest-panel">
            <div class="product-suggest-panel__head">
              <span>
                <i v-if="suggestLoading" class="el-icon-loading"></i>
                {{ suggestLoading ? '正在生成字段建议…' : '字段建议（仅填空项）' }}
              </span>
              <el-button
                v-if="suggestKeys.length"
                type="primary"
                size="mini"
                :disabled="suggestLoading"
                @click="applyProductSuggestions"
              >一键采纳空字段</el-button>
            </div>
            <div v-if="suggestKeys.length" class="product-suggest-panel__tags">
              <el-tag
                v-for="key in suggestKeys"
                :key="key"
                size="mini"
                type="info"
                style="margin:2px"
              >{{ suggestFieldLabel(key) }}：{{ formatSuggestValue(key, productSuggestions[key]) }}</el-tag>
            </div>
          </div>
          <div class="form-columns">
          <div class="form-box">
            <el-form-item label="id" prop="id" v-show="false">
              <el-input v-model="ruleForm.id"></el-input>
            </el-form-item>
            <el-form-item label="中文名称" prop="name">
              <el-input v-model="ruleForm.name" @blur="scheduleProductSuggest"></el-input>
            </el-form-item>
            <el-form-item label="英文名称" prop="ename">
              <el-input v-model="ruleForm.ename" @blur="scheduleProductSuggest"></el-input>
            </el-form-item>
            <el-form-item label="SKU" prop="sku">
              <el-input v-model="ruleForm.sku" placeholder="与领星一致，最长64" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="FNSKU" prop="fnsku">
              <el-input v-model="ruleForm.fnsku" placeholder="产品标 FNSKU" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="ASIN" prop="asin">
              <el-input v-model="ruleForm.asin" placeholder="亚马逊 ASIN" maxlength="64" @blur="scheduleProductSuggest"></el-input>
            </el-form-item>
            <el-form-item label="产品条码" prop="productCode">
              <el-input v-model="ruleForm.productCode"></el-input>
            </el-form-item>
            <el-form-item label="材质" prop="material">
              <el-input v-model="ruleForm.material" placeholder="中英文"></el-input>
            </el-form-item>
            <el-form-item label="用途" prop="purpose">
              <el-input v-model="ruleForm.purpose" placeholder="中英文"></el-input>
            </el-form-item>
            <el-form-item label="型号" prop="model">
              <el-input v-model="ruleForm.model"></el-input>
            </el-form-item>
            <el-form-item label="国家" prop="country">
              <Country :countrys="ruleForm.country" @getCty="getCountry"></Country>
            </el-form-item>
            <el-form-item label="报关编码">
              <el-input v-model="ruleForm.hscode"></el-input>
            </el-form-item>
            <el-form-item label="清关编码">
              <el-input v-model="ruleForm.gwcode"></el-input>
            </el-form-item>
            <el-form-item label="税率">
              <el-input v-model="ruleForm.taxRate"></el-input>
            </el-form-item>
            <el-form-item label="制造商">
              <el-input v-model="ruleForm.maker"></el-input>
            </el-form-item>
          </div>
          <div class="form-box">
            <el-form-item label="品牌">
              <el-input v-model="ruleForm.brand"></el-input>
            </el-form-item>
            <el-form-item label="品牌类型" prop="brandType">
              <el-select v-model="ruleForm.brandType" clearable placeholder="请选择">
                <el-option
                  v-for="item in brandType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="出口享惠" prop="exportBenefits">
              <el-select v-model="ruleForm.exportBenefits" clearable placeholder="请选择">
                <el-option
                  v-for="item in exportBenefits"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="带电带磁" prop="electrificationState">
              <el-select v-model="ruleForm.electrificationState" clearable placeholder="请选择">
                <el-option
                  v-for="item in electrificationState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="单价" prop="price">
              <el-input v-model="ruleForm.price" placeholder="不能超过两位小数"></el-input>
            </el-form-item>
            <el-form-item label="申报币种">
              <el-select v-model="ruleForm.currencyCode" clearable placeholder="请选择">
                <el-option
                  v-for="item in currencyCode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="尺寸">
              <el-input v-model="ruleForm.size" placeholder="长*宽*高cm"></el-input>
            </el-form-item>
            <el-form-item label="英制长度">
              <el-input v-model="ruleForm.InchLength" placeholder="长（英寸）"></el-input>
            </el-form-item>
            <el-form-item label="英制宽度">
              <el-input v-model="ruleForm.InchWidth" placeholder="宽（英寸）"></el-input>
            </el-form-item>
            <el-form-item label="英制高度">
              <el-input v-model="ruleForm.InchHeight" placeholder="高（英寸）"></el-input>
            </el-form-item>
            <el-form-item label="重量">
              <el-input v-model="ruleForm.weight" placeholder="重量"></el-input>
            </el-form-item>
            <el-form-item label="重量单位">
              <el-select v-model="ruleForm.weightUnit" clearable placeholder="请选择">
                <el-option
                  v-for="item in weightUnit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </div>
          <div class="form-box">
            <el-form-item label="链接">
              <el-input v-model="ruleForm.makerAdd" placeholder="销售链接 / 亚马逊链接" @blur="scheduleProductSuggest"></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
              <el-upload
                class="upload-demo"
                :action="uploadAction"
                :headers="uploadHeaders"
                :on-success="handSuccess"
                :on-remove="handRemove"
                :before-upload="beforeUpload"
                :file-list="fileList"
                list-type="picture"
                :limit="1"
                name="upload"
              >
                <el-button size="small" type="primary">
                  点击上传
                  <i class="el-icon-upload el-icon--right"></i>
                </el-button>
              </el-upload>
            </el-form-item>
          </div>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" :loading="submitting" @click="submitForm('ruleForm')">
            {{ isAddMode ? '添 加' : '修 改' }}
          </el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import httpApi from "@/http/api";
import { buildGoodsRiskConfirmLines } from "@/utils/goodsRisk";
import Country from "@/components/Country";

const BRAND_TYPE_MAP = {
  "0": "无品牌",
  "1": "境内自主品牌",
  "2": "境内收购品牌",
  "3": "境外品牌（贴牌生产）",
  "4": "境外品牌（其他）"
};

const STATUS_TYPE_MAP = {
  0: "info",
  1: "warning",
  2: "success",
  3: "danger",
  4: "info"
};

const STATUS_TEXT_MAP = {
  0: "待审核",
  1: "审核中",
  2: "已审核",
  3: "已驳回",
  4: "废弃"
};

function getDefaultRuleForm() {
  return {
    id: 0,
    name: "",
    ename: "",
    country: "美国",
    hscode: "",
    gwcode: "",
    taxRate: "",
    material: "",
    model: "",
    purpose: "",
    brand: "",
    picName: "",
    picUrl: "",
    brandType: "",
    exportBenefits: "",
    electrificationState: "",
    maker: "",
    makerAdd: "",
    price: "",
    sku: "",
    fnsku: "",
    asin: "",
    currencyCode: "",
    productCode: "",
    InchLength: "",
    InchWidth: "",
    InchHeight: "",
    weight: "",
    weightUnit: "",
    size: ""
  };
}

export default {
  name: "Products",
  components: {
    Country
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
        return callback();
      }
      if (!/^\d+(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error("最多两位小数"));
      } else {
        callback();
      }
    };
    return {
      uploadHeaders: { token: sessionStorage.getItem("token") || "" },
      productData: [],
      dialogFormVisible: false,
      isAddMode: true,
      fileList: [],
      inputVal: "",
      inputSku: "",
      currentPage: 1,
      pagesize: 20,
      total: 0,
      tableHeight: 400,
      editIndex: 0,
      loading: false,
      submitting: false,
      productRiskTip: "",
      productSuggestions: {},
      productSuggestSources: {},
      suggestLoading: false,
      _suggestTimer: null,
      ruleForm: getDefaultRuleForm(),
      rules: {
        name: [{ required: true, message: "请输入中文名称", trigger: "blur" }],
        ename: [{ required: true, message: "请输入英文名称", trigger: "blur" }],
        sku: [
          { required: true, message: "请输入 SKU", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const v = (value || "").trim();
              if (!v) {
                callback(new Error("请输入 SKU"));
              } else if (v.length > 64) {
                callback(new Error("SKU 最长 64 字符（与领星一致）"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        price: [{ validator: validatePrice, trigger: "blur" }],
        material: [{ required: true, message: "请输入材质", trigger: "blur" }],
        purpose: [{ required: true, message: "请输入用途", trigger: "blur" }]
      },
      brandType: [
        { label: "无品牌", value: "0" },
        { label: "境内自主品牌", value: "1" },
        { label: "境内收购品牌", value: "2" },
        { label: "境外品牌(贴牌生产)", value: "3" },
        { label: "境外品牌(其他)", value: "4" }
      ],
      exportBenefits: [
        { label: "出口货物在最终目的国（地区）不享受优惠关税", value: "0" },
        { label: "出口货物在最终目的国（地区）享受优惠关税", value: "1" },
        {
          label: "出口货物不能确定在最终目的国（地区）享受优惠关税",
          value: "2"
        }
      ],
      currencyCode: [
        { label: "USD", value: "USD" },
        { label: "JPY", value: "JPY" },
        { label: "RMB", value: "RMB" }
      ],
      weightUnit: [
        { label: "kg", value: "kg" },
        { label: "lb", value: "lb" }
      ],
      electrificationState: [
        { label: "否", value: "0" },
        { label: "内置电池", value: "1" },
        { label: "配套电池", value: "2" },
        { label: "纯电池", value: "3" },
        { label: "液体", value: "4" },
        { label: "膏体", value: "5" },
        { label: "粉末", value: "6" },
        { label: "带磁", value: "7" }
      ]
    };
  },
  computed: {
    uploadAction() {
      return this.mApi + "file/upload";
    },
    suggestKeys() {
      return Object.keys(this.productSuggestions || {});
    }
  },
  mounted() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
  },
  activated() {
    this.updateTableHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
  },
  methods: {
    updateTableHeight() {
      this.$nextTick(() => {
        const wrap = this.$refs.tableWrap;
        if (wrap && wrap.clientHeight > 0) {
          this.tableHeight = wrap.clientHeight;
        }
      });
    },
    normalizeStatus(status) {
      const num = Number(status);
      return Number.isNaN(num) ? status : num;
    },
    getStatusType(status) {
      return STATUS_TYPE_MAP[this.normalizeStatus(status)] || "info";
    },
    getStatusText(status) {
      return STATUS_TEXT_MAP[this.normalizeStatus(status)] || "未知状态";
    },
    riskTagLabels(tags) {
      const map = {
        policy: "政策敏感",
        dual_use: "军民两用",
        antidumping: "反倾销",
        control: "布控",
        high_inspect: "查验高",
        cert: "认证多"
      };
      return String(tags || "")
        .split(/[,;，、\s]+/)
        .filter(Boolean)
        .map((t) => map[t] || t);
    },
    enrichProductRow(row) {
      const item = { ...row };
      item.brandTypeTxt = BRAND_TYPE_MAP[item.brandType] || "";
      const exportItem = this.exportBenefits.find(e => e.value === String(item.exportBenefits));
      item.exportBenefitsTxt = exportItem ? exportItem.label : "";
      const elecItem = this.electrificationState.find(e => e.value === String(item.electrificationState));
      item.electrificationStateTxt = elecItem ? elecItem.label : "";
      return item;
    },
    buildProductPayload() {
      const form = this.ruleForm;
      const payload = {
        brand: form.brand,
        country: form.country,
        ename: form.ename,
        hscode: form.hscode,
        gwcode: form.gwcode,
        taxRate: form.taxRate,
        maker: form.maker,
        makerAdd: form.makerAdd,
        material: form.material,
        name: form.name,
        picName: form.picName,
        picUrl: form.picUrl,
        purpose: form.purpose,
        model: form.model,
        brandType: form.brandType,
        exportBenefits: form.exportBenefits,
        electrificationState: form.electrificationState,
        size: form.size,
        sku: form.sku,
        fnsku: form.fnsku,
        asin: form.asin,
        currencyCode: form.currencyCode,
        productCode: form.productCode,
        InchLength: form.InchLength === "" ? null : Number(form.InchLength),
        InchWidth: form.InchWidth === "" ? null : Number(form.InchWidth),
        InchHeight: form.InchHeight === "" ? null : Number(form.InchHeight),
        weight: form.weight === "" ? null : Number(form.weight),
        weightUnit: form.weightUnit
      };
      if (form.price !== "" && form.price !== null && form.price !== undefined) {
        payload.price = Number(form.price);
      }
      if (!this.isAddMode) {
        payload.id = form.id;
      }
      return payload;
    },
    addSup() {
      this.isAddMode = true;
      this.ruleForm = getDefaultRuleForm();
      this.fileList = [];
      this.productRiskTip = "";
      this.productSuggestions = {};
      this.productSuggestSources = {};
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    closeDialog() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
      this.productRiskTip = '';
      this.productSuggestions = {};
      this.productSuggestSources = {};
      this.dialogFormVisible = false;
    },
    suggestFieldLabel(key) {
      const map = {
        name: "中文名",
        ename: "英文名",
        hscode: "报关编码",
        material: "材质",
        purpose: "用途",
        brand: "品牌",
        electrificationState: "带电带磁",
        asin: "ASIN",
        selleLink: "链接",
        picUrl: "图片",
        size: "尺寸",
        weight: "重量"
      };
      return map[key] || key;
    },
    formatSuggestValue(key, val) {
      if (key === "electrificationState") {
        const hit = (this.electrificationState || []).find(x => String(x.value) === String(val));
        return hit ? hit.label : val;
      }
      const s = val == null ? "" : String(val);
      return s.length > 28 ? s.slice(0, 28) + "…" : s;
    },
    scheduleProductSuggest() {
      if (this._suggestTimer) clearTimeout(this._suggestTimer);
      this._suggestTimer = setTimeout(() => {
        this.runProductSuggest();
      }, 400);
    },
    async runProductSuggest() {
      const name = (this.ruleForm.name || "").trim();
      const ename = (this.ruleForm.ename || "").trim();
      const asin = (this.ruleForm.asin || "").trim();
      const link = (this.ruleForm.makerAdd || "").trim();
      if (!name && !ename && !asin && !link) {
        this.productRiskTip = "";
        this.productSuggestions = {};
        this.productSuggestSources = {};
        return;
      }
      this.suggestLoading = true;
      try {
        const res = await httpApi.productSuggest({
          name,
          ename,
          country: this.ruleForm.country,
          asin,
          selleLink: link
        });
        if (res.data.code !== "ok") {
          return;
        }
        const data = res.data.data || {};
        this.productSuggestions = data.suggestions || {};
        this.productSuggestSources = data.sources || {};
        const risk = data.risk || {};
        if (risk.hit) {
          const lines = buildGoodsRiskConfirmLines({
            items: [{ hit: true, name, ename, hits: risk.hits || [] }],
            message: risk.message
          });
          this.productRiskTip = lines.join("；") || risk.message || "品名存在合规风险提示";
        } else {
          this.productRiskTip = "";
        }
      } catch (e) {
        /* 建议失败不阻断 */
      } finally {
        this.suggestLoading = false;
      }
    },
    applyProductSuggestions() {
      const sug = this.productSuggestions || {};
      let applied = 0;
      const empty = (v) => v === null || v === undefined || String(v).trim() === "";
      Object.keys(sug).forEach((key) => {
        const val = sug[key];
        if (val === null || val === undefined || String(val).trim() === "") return;
        if (key === "selleLink") {
          if (empty(this.ruleForm.makerAdd)) {
            this.ruleForm.makerAdd = String(val);
            applied++;
          }
          return;
        }
        if (key === "picUrl") {
          if (empty(this.ruleForm.picUrl)) {
            this.ruleForm.picUrl = String(val);
            this.ruleForm.picName = this.ruleForm.picName || "amazon";
            this.fileList = [{ name: "amazon", url: String(val) }];
            applied++;
          }
          return;
        }
        if (Object.prototype.hasOwnProperty.call(this.ruleForm, key) && empty(this.ruleForm[key])) {
          this.ruleForm[key] = String(val);
          applied++;
        }
      });
      if (applied > 0) {
        this.$message.success(`已采纳 ${applied} 个空字段`);
      } else {
        this.$message.info("没有可填的空字段（已填项不会被覆盖）");
      }
    },
    async checkProductRisk() {
      try {
        const name = this.ruleForm.name;
        const ename = this.ruleForm.ename;
        if (!name && !ename) {
          this.productRiskTip = '';
          return false;
        }
        const res = await httpApi.goodsRiskCheck({
          name,
          ename,
          country: this.ruleForm.country
        });
        if (res.data.code !== 'ok') return false;
        const data = res.data.data || {};
        if (!data.hit) {
          this.productRiskTip = '';
          return false;
        }
        const lines = buildGoodsRiskConfirmLines({
          items: [{ hit: true, name, ename, hits: data.hits || [] }],
          message: data.message
        });
        this.productRiskTip = lines.join('；') || data.message || '品名存在合规风险提示';
        return true;
      } catch (e) {
        return false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return false;
        }
        const hit = await this.checkProductRisk();
        if (hit) {
          try {
            await this.$confirm(
              (this.productRiskTip || '品名存在合规风险提示') + '\n\n仅提醒，可继续保存产品。',
              '品名合规提示',
              { type: 'warning', confirmButtonText: '已知晓，继续', cancelButtonText: '返回修改' }
            );
          } catch (e) {
            return;
          }
        }
        const payload = this.buildProductPayload();
        const request = this.isAddMode
          ? httpApi.addProduct(payload)
          : httpApi.updateProdct(payload);

        this.submitting = true;
        request
          .then(res => {
            if (res.data.code === "ok") {
              this.$message.success(this.isAddMode ? "添加成功！" : "修改成功！");
              this.dialogFormVisible = false;
              this.productRiskTip = '';
              this.productSuggestions = {};
              this.productSuggestSources = {};
              this.$refs[formName].resetFields();
              this.queryProduct();
            } else {
              this.$message.error(res.data.message || "操作失败");
            }
          })
          .catch(error => {
            console.error("保存产品异常:", error);
            this.$message.error("保存失败，请稍后重试");
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    getCountry(value) {
      this.ruleForm.country = value;
    },
    handleEdit(index, row) {
      this.isAddMode = false;
      this.editIndex = index;
      this.productRiskTip = "";
      this.productSuggestions = {};
      this.productSuggestSources = {};
      this.ruleForm = {
        ...getDefaultRuleForm(),
        id: row.id,
        name: row.name || "",
        ename: row.ename || "",
        country: row.country || "美国",
        hscode: row.hscode || "",
        gwcode: row.gwcode || "",
        taxRate: row.taxRate || "",
        maker: row.maker || "",
        sku: row.sku || "",
        fnsku: row.fnsku || "",
        asin: row.asin || "",
        makerAdd: row.makerAdd || "",
        material: row.material || "",
        price: row.price != null ? row.price : "",
        purpose: row.purpose || "",
        picName: row.picName || "",
        picUrl: row.picUrl || "",
        model: row.model || "",
        brand: row.brand || "",
        brandType: row.brandType != null ? String(row.brandType) : "",
        exportBenefits: row.exportBenefits != null ? String(row.exportBenefits) : "",
        electrificationState: row.electrificationState != null ? String(row.electrificationState) : "",
        size: row.size || "",
        currencyCode: row.currencyCode || "",
        productCode: row.productCode || "",
        InchLength: row.InchLength != null ? row.InchLength : "",
        InchWidth: row.InchWidth != null ? row.InchWidth : "",
        InchHeight: row.InchHeight != null ? row.InchHeight : "",
        weight: row.weight != null ? row.weight : "",
        weightUnit: row.weightUnit || ""
      };
      this.fileList = row.picUrl
        ? [{ name: row.picName || "产品图片", url: row.picUrl }]
        : [];
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该产品，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return httpApi.delProduct({}, { params: { id: row.id } });
        })
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success("删除成功！");
            if (this.productData.length === 1 && this.currentPage > 1) {
              this.currentPage -= 1;
            }
            this.queryProduct();
          } else {
            this.$message.error(res.data.message || "删除失败");
          }
        })
        .catch(action => {
          if (action !== "cancel") {
            console.error("删除产品异常:", action);
          }
        });
    },
    handSuccess(response) {
      if (response && response.code === "ok" && response.data) {
        this.ruleForm.picName = response.data.filename;
        this.ruleForm.picUrl = response.data.url;
      } else {
        this.$message.error((response && response.message) || "上传失败");
      }
    },
    beforeUpload(file) {
      this.uploadHeaders = { token: sessionStorage.getItem("token") || "" };
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isAllowed = allowedTypes.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isAllowed) {
        this.$message.error("只能上传 jpg 或 png 格式的图片");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB");
      }
      return isAllowed && isLt2M;
    },
    handRemove() {
      this.ruleForm.picName = "";
      this.ruleForm.picUrl = "";
      this.fileList = [];
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.queryProduct();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.queryProduct();
    },
    handleSearch() {
      this.currentPage = 1;
      this.queryProduct();
    },
    queryProduct() {
      this.loading = true;
      httpApi
        .queryProduct({
          params: {
            page: this.currentPage,
            rows: this.pagesize,
            name: this.inputVal || undefined,
            sku: this.inputSku || undefined
          }
        })
        .then(res => {
          if (res.data.code === "ok") {
            const pageData = res.data.data || {};
            this.productData = (pageData.rows || []).map(row => this.enrichProductRow(row));
            this.total = pageData.total || 0;
          } else {
            this.$message.error(res.data.message || "获取产品列表失败");
          }
        })
        .catch(error => {
          console.error("查询产品异常:", error);
          this.$message.error("获取产品列表失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
          this.updateTableHeight();
        });
    }
  },
  created() {
    this.queryProduct();
  }
};
</script>

<style lang="less" scoped>
.products {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 70px - 34px - 35px);
  min-height: 420px;
  overflow: hidden;
  box-sizing: border-box;

  /deep/ .el-breadcrumb {
    flex-shrink: 0;
    margin-bottom: 12px;
  }
}

.main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ .el-card__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
}

.card-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.table-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.pagination-bar {
  flex-shrink: 0;
  padding: 10px 16px;
  text-align: center;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  .el-input {
    width: 200px;
  }
}

.sub-text {
  color: #909399;
  font-size: 12px;
}

.image-placeholder {
  font-size: 30px;
  color: #c0c4cc;
}

.empty-tip {
  color: #909399;
  font-size: 14px;
}

/deep/.el-dialog {
  .el-dialog__body {
    padding-bottom: 0;
    .el-form {
      display: block;
      .product-risk-alert {
        width: 100%;
        margin-bottom: 12px;
        box-sizing: border-box;
        .el-alert__description {
          word-break: break-word;
          white-space: normal;
          line-height: 1.5;
        }
      }
      .product-suggest-panel {
        width: 100%;
        margin-bottom: 12px;
        padding: 10px 12px;
        box-sizing: border-box;
        background: #f4f8ff;
        border: 1px solid #d9ecff;
        border-radius: 4px;
        &__head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          margin-bottom: 6px;
          font-size: 13px;
          color: #409eff;
        }
        &__tags {
          line-height: 1.6;
        }
      }
      .form-columns {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      }
      .form-box {
        width: 50%;
        box-sizing: border-box;
      }
    }
    /deep/.el-input,
    .el-textarea {
      float: left;
      width: 80%;
      .el-textarea__inner {
        height: 80px;
      }
    }
    .el-form-item__content {
      text-align: left;
      .el-select {
        position: absolute;
        width: 100%;
      }
    }
    .el-upload-list {
      width: 92%;
    }
  }
}

/deep/.el-form-item__label {
  font-size: 13px;
}
</style>
